import { environment } from "../../../../../environments/environment";
import { WebtraderService } from "../../../service/webtrader-service/webtrader.service";
import { Art57Section } from "../../Art57Section/Art57Section";
import { InBoxListView } from "../../Data/WebTraderData/InBoxListView";
import { OutBoxListView } from "../../Data/WebTraderData/OutboxListView";
import { QueryResultNode } from "../QueryResultNode";
import { EntityEnum } from "../EntityEnum";
import { ToEudravigilanceListView } from "../../Data/WebTraderData/ToEudravigilanceListView";

export class WebTraderQueryResultNode extends QueryResultNode {
    exportToExcel(){
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel file...', life: environment.successElapsedTime });
        let entity: string = '';
        
        entity = this.entityName;
        if (this.data instanceof InBoxListView) {
          entity = EntityEnum.inb;
        } else if (this.data instanceof OutBoxListView) {
          entity = EntityEnum.oub;
        } else if (this.data instanceof ToEudravigilanceListView) {
          entity = EntityEnum.toEV;
        }
    
        this.ioc!.get(WebtraderService).exportResultsToExcel(entity, this.data.model)
          .subscribe({
            next: (blob: any) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'export-'+this.getDate()+'.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel finished', life: environment.successElapsedTime });
            },
            error: (error: any) => {
              this.ioc!.get(Art57Section).showTooltipMessage({
                severity: 'error',
                detail: 'Error found',
                life: environment.errorElapsedTime,
              });
            },
          });
      }
      getDate(): string {
        const date = new Date();
    
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hour = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
    
        return `${year}-${month}-${day}+${hour}.${minutes}.${seconds}`;
      }
      
        
}